import {
  DETAILS_TRANSACTIONS_PREPAID_FRAUD,
  DETAILS_TRANSACTIONS_PREPAID_FRAUD_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const postTransactionsPrepaidFraud =
  (prepaid_transaction_id, descriptionTransaction) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const response = await axiosTokenInstance.post(
        `api/prepaids/${prepaid_transaction_id}/fraud`,
        {
          reason: descriptionTransaction,
        },
      );

      const { data, status } = response || {};

      dispatch({
        type: DETAILS_TRANSACTIONS_PREPAID_FRAUD,
        payload: data || {},
        status: status || {},
        method: 'post',
      });
    } catch (e) {
      dispatch({
        type: DETAILS_TRANSACTIONS_PREPAID_FRAUD_ERROR,
        payload: e || {},
      });
    }
  };
